<template>
  <div class="car">
    <custom-plane
      title="车位信息"
      :iconImg="require('@/assets/compImg/parking/carspace.png')"
    >
      <div class="car_data">
        <div class="car_title">编号</div>
        <div class="car_infor" v-if="number.includes('人')">
          <div class="data">{{ number.slice(0, 2) }}</div>
          <div class="text">{{ number.slice(2) }}</div>
        </div>
        <div class="car_infor" v-else>
          {{ number }}
        </div>
      </div>
    </custom-plane>
  </div>
</template>
<script>
export default {
  props: {
    number: String,
  },
};
</script>
<style lang="scss" scoped>
.car {
  margin-top: 20px;
  width: 416px;
  height: 127px;
}
</style>
